import React from "react";
import Container from "react-bootstrap/Container";
import { Nav } from "react-bootstrap";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { HashLink as Link } from "react-router-hash-link";
import YouTube from "react-youtube";
import { useDispatch } from "react-redux";
import { videoAccessLog } from "../../actions/videoAccessLog";

const LivingWellCenter2_1_PreSurgical = () => {
  const opts = {
    height: "390",
    width: "640",
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 0,
    },
  };

  const dispatch = useDispatch();
  const playWhatToExpect = async (e) => {
    const pal = await videoAccessLog(
      {
        videoName:
          "What to Expect at the Living Well Center (Dr. John Metzler)",
      },
      () => {
        console.log(
          "What to Expect at the Living Well Center (Dr. John Metzler)"
        );
      }
    );
    await dispatch(pal);
  };

  return (
    <div>
      <div className="w-100 legosNewBuild livingWellCenterHeader">
        <section className="mb-0">
          {/* L6 Background image header bar */}
          <div className="lego l006 legoMargin5">
            <div
              className="backgroundImage"
              style={{
                backgroundImage:
                  "url(" +
                  "https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/a5bad22dbca04a5d88957e35816ad470.jpeg" +
                  ")",
              }}
            >
              <div
                className="transparentBarTypeContainer"
                style={{
                  backgroundColor: "#91651E",
                }}
              >
                &nbsp;&nbsp;
              </div>
              <h2 className="l6SubheadWithBackground">Making Your Plan</h2>
            </div>
          </div>
          {/* End L6 Background image header bar */}
        </section>
        <Container>
          <div className="w-100">
            <div className="col-12 m-auto">
              <div className="whiteBackground floatLeft clearLeft legosNewBuild livingWellCenterHeader">
                <section>
                  {/* L12A Head, Lead In Photo Larger with body copy */}
                  <div className="lego l012A">
                    <div className="contentContainer">
                      <div className="imgContainer1">
                        <img
                          className=""
                          alt=""
                          src="https://orbit-image-video-bucket.s3.us-east-2.amazonaws.com/94ebedd43b0d25f09934453b9b5f75aa.jpeg"
                        />
                      </div>
                      <div className="copyContainer">
                        {/* L14 Paragraph */}
                        <div className="lego l00paragraph noMarginBottom">
                          <p
                            className="legoMargin3"
                            style={{ fontSize: "22px", lineHeight: "33px" }}
                          >
                            <span className="paragraph22px">
                              Determining how the Living Well Center can best work with you is easy.
                            </span>
                            <br />
                            It all begins with a consultation that you can schedule simply by calling
                            <span
                              className="paragraph22px"
                              style={{ fontStyle: "normal" }}
                            >
                              314.514.3565
                            </span>
                          </p>
                          <p
                            className="legoMargin3 "
                            style={{ fontSize: "22px", lineHeight: "33px" }}
                          >
                            When you come for that first visit at the Living Well Center, we’ll spend time listening and  discussing what is important you, what you’re trying to accomplish, and what your barriers to your health have been.
                          </p>
                          <p
                            className="legoMargin3"
                            style={{ fontSize: "22px", lineHeight: "33px" }}
                          >
                            Then we'll work together to design a specific plan, whether that’s to accomplish some weight loss, or to work on improving your exercise regimen or simply just managing your stress a little bit better. And you'll leave with specific actionable items and a good understanding of how our team can support you.
                          </p>
                          <p
                            className="legoMargin3"
                            style={{ fontSize: "22px", lineHeight: "33px" }}
                          >
                            And the Living Well Center initial visit is billed to insurance just like a specialist medical visit.
                          </p>
                        </div>
                        {/* End L14 Paragraph */}
                      </div>
                    </div>
                  </div>
                  {/* End L12A Head, Lead In Photo Larger with body copy */}

                  {/* L66 Divider Rule */}
                  <div className="lego l066">
                    <hr className="horizonalRule" />
                  </div>
                  {/* End L66 Divider Rule */}

                  {/* L4 Subhead Upper */}
                  <div className="lego l004 legoMargin2">
                    <h2 className="subHeadAllCaps2">
                      WHAT TO EXPECT
                    </h2>
                  </div>
                  {/* End L4 Subhead Upper */}

                  {/* L31 Video Box Large */}
                  <div className="lego l031 legoMargin2">
                    <div className="videoContainer">
                      <div className="embedContainer originalPadding">
                        <YouTube
                          videoId="yRn5TKGnE70"
                          opts={opts}
                          onPlay={playWhatToExpect}
                        />
                      </div>
                      <h3 className="videoTitle w-100 text-center text-dark">
                        Watch:{" "}
                        <span className="videoTitleTreatment">
                          WE'RE HERE TO WORK WITH YOU
                        </span>
                      </h3>
                    </div>
                  </div>
                  {/* End L31 Video Box Large */}

                  {/* L14 Paragraph */}

                  <div className="lego l00paragraph legoMargin2">
                    <p>
                      At the Living Well Center, we understand that a positive patient experience begins with active listening. With every moment you work with us, you can expect to be heard.
                    </p>
                  </div>

                  <div className="lego l00paragraph legoMargin2">
                    <p>
                      From your first visit, you can expect to treated as a whole person, with care taken to understand all aspects of your life that could effect your health and success. Your experience will begin with a simple conversation with a team deeply committed to finding the right path for you to achieve exactly what you’re hoping for.
                    </p>
                  </div>

                  <div className="lego l00paragraph legoMargin5">
                    <p>
                      From that first visit, you’ll receive our assessment of what combination of services can best help you reach your goals. And then we’ll sit down and develop your plan together.
                    </p>
                  </div>

                  {/* End L14 Paragraph */}

                  <div className="col-12 backToTop">
                    <div className="w-100">
                      <p>
                        <a
                          className="specialUseBackToTop"
                          onClick={() =>
                            window.scrollTo({ top: 0, behavior: "smooth" })
                          }
                        >
                          BACK TO TOP{" "}
                        </a>
                      </p>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default LivingWellCenter2_1_PreSurgical;
